import "./Filter.css";

export default function Filter(props) {
  return (
    <div className="filter">
      <div className="filterleft"></div>
      <div className="filterright">
        <button
          onClick={() => {
            props.close();
          }}
          className={"dropbtnNavSub textwhite sell marginright marginleft"}
        >
          Close
        </button>
      </div>
    </div>
  );
}
